module.exports = __webpack_public_path__ + "static/media/13.4d434ebc.jpg";